import React from "react";
import {
    Box,
    Button,
    Card,
    CardContent,
    Container,
    Grid,
    Typography,
    useTheme
} from "@mui/material";

import {
    ArrowForward,
    Assignment,
    Description,
    Stars,
    MenuBook,
    WorkOutline,
    CheckCircleOutline
} from "@mui/icons-material";

const features = [
    {
        title: "Interview Tracker",
        description:
            "Track every company, status, interview, and next step.",
        icon: <Assignment fontSize="large" />
    },
    {
        title: "Files",
        description:
            "Store and manage your resumes, cover letters, and important docs.",
        icon: <Description fontSize="large" />
    },
    {
        title: "AI Jobsearch Tools",
        description:
            "AI-powered tools to find better matches and tailor your applications.",
        icon: <Stars fontSize="large" />
    },
    {
        title: "Practical Guidelines",
        description:
            "Step-by-step guides, templates, and tips to improve your edge.",
        icon: <MenuBook fontSize="large" />
    },
    {
        title: "Real Time Job Board",
        description:
            "Discover relevant opportunities updated in real time.",
        icon: <WorkOutline fontSize="large" />
    },
    {
        title: "Interview Recaps",
        description:
            "Learn from real interview experiences by company, title, and stage - and share your own insights to help future candidates.",
        icon: <Assignment fontSize="large" />
    }
];

const bullets = [
    "All-in-one workspace",
    "Stay organized",
    "Make better progress",
    "Land your dream role"
];

export default function JourneyNotLogedin(props) {
    const theme = useTheme();

    return (
        <Box bgcolor="#fff">
            <Container maxWidth='lg'>
            <div style={{background: 'linear-gradient(211deg, #d6c8fb, transparent 39%)', border: '1px solid #ebebeb', borderRadius: 16, padding: '40px 32px', marginTop: 32, boxShadow: 'rgba(0, 0, 0, 0.1) 0px 1px 2px 0px'}}>
                <Box
                    display="inline-flex"
                    alignItems="center"
                    px={2}
                    py={0.5}
                    borderRadius="8px"
                    bgcolor="rgba(0,0,0,0.04)"
                    mb={3}
                    style={{backgroundColor: '#efeff9'}}
                >
                    <Stars
                        style={{
                            fontSize: 16,
                            marginRight: 6,
                            color: '#695cb4'
                        }}
                        color="primary"
                    />

                    <Typography
                        variant="body2"
                        color="primary"
                        style={{ fontWeight: 600, color: '#695cb4' }}
                    >
                        Welcome to JobHunt Journey
                    </Typography>
                </Box>

                <div>
                    <Typography
                        variant="h2"
                        style={{
                            fontWeight: 800,
                            lineHeight: 1.1,
                            marginBottom: 24,
                            fontSize: 56
                        }}
                    >
                        Turn your job search
                        <br />
                        into a{" "}
                        <span style={{color:theme.palette.primary.main}}>
                            managed journey
                        </span>
                    </Typography>

                    <Typography
                        variant="h6"
                        color="textSecondary"
                        style={{
                            lineHeight: 1.7,
                            maxWidth: 520,
                            marginBottom: 32,
                            fontWeight: 400
                        }}
                    >
                        JobHunt Journey helps you organize applications,
                        prepare interviews, track opportunities, and stay
                        focused from first search to signed offer.
                    </Typography>

                    <Box
                        display="flex"
                        alignItems="center"
                        gap={16}
                        flexWrap="wrap"
                        mb={5}
                    >
                        <Button
                            variant="contained"
                            color="primary"
                            size="large"
                            onClick={props.handleLogin}
                            style={{
                                minWidth: 170,
                                height: 52,
                                borderRadius: 10,
                                fontWeight: 700,
                                textTransform: "none"
                            }}
                        >
                            Log In to Start
                        </Button>

                        {/*<Button
                            variant="outlined"
                            color="primary"
                            size="large"
                            endIcon={<ArrowForward />}
                            style={{
                                minWidth: 170,
                                height: 52,
                                borderRadius: 10,
                                fontWeight: 700,
                                textTransform: "none"
                            }}
                        >
                            See Features
                        </Button>*/}
                    </Box>
                </div>

                <Box
                    display="flex"
                    flexWrap="wrap"
                    gap={28}
                >
                    {bullets.map((item) => (
                        <Box
                            key={item}
                            display="flex"
                            alignItems="center"
                        >
                            <CheckCircleOutline
                                color="primary"
                                style={{
                                    marginRight: 8,
                                    fontSize: 20
                                }}
                            />

                            <Typography
                                variant="body2"
                                style={{ fontWeight: 500 }}
                            >
                                {item}
                            </Typography>
                        </Box>
                    ))}
                </Box>
            </div>

            {/* FEATURES */}
            <Box py={7}>
                <Box textAlign="center" mb={5}>
                    <Typography
                        variant="h4"
                        style={{
                            fontWeight: 800,
                            marginBottom: 12
                        }}
                    >
                        Everything you need to succeed
                    </Typography>

                    <Typography
                        variant="h6"
                        color="textSecondary"
                        style={{
                            fontWeight: 400
                        }}
                    >
                        Powerful tools to help you stay organized,
                        prepared, and one step ahead.
                    </Typography>
                </Box>

                <Grid container spacing={3}>
                    {features.map((feature) => (
                        <Grid item xs={12} md={4} key={feature.title}>
                            <Card
                                elevation={0}
                                style={{
                                    border: "1px solid rgba(0,0,0,0.08)",
                                    borderRadius: 16,
                                    height: "100%",
                                    boxShadow: 'rgba(0, 0, 0, 0.1) 0px 1px 2px 0px'
                                }}
                            >
                                <CardContent
                                    style={{
                                        padding: 24
                                    }}
                                >
                                    <Box
                                        display="flex"
                                        justifyContent="space-between"
                                        alignItems="flex-start"
                                    >
                                        <Box display="flex">
                                            <Box
                                                width={56}
                                                height={56}
                                                borderRadius="50%"
                                                display="flex"
                                                alignItems="center"
                                                justifyContent="center"
                                                bgcolor="rgba(0,0,0,0.04)"
                                                color="primary.main"
                                                mr={2}
                                                flexShrink={0}
                                            >
                                                {feature.icon}
                                            </Box>

                                            <Box>
                                                <Typography
                                                    variant="h6"
                                                    style={{
                                                        fontWeight: 700,
                                                        marginBottom: 8
                                                    }}
                                                >
                                                    {feature.title}
                                                </Typography>

                                                <Typography
                                                    variant="body2"
                                                    color="textSecondary"
                                                    style={{
                                                        lineHeight: 1.7
                                                    }}
                                                >
                                                    {feature.description}
                                                </Typography>
                                            </Box>
                                        </Box>

                                        <ArrowForward
                                            color="action"
                                            style={{
                                                marginLeft: 12
                                            }}
                                        />
                                    </Box>
                                </CardContent>
                            </Card>
                        </Grid>
                    ))}
                </Grid>
            </Box>
            </Container>
        </Box>
    );
}